import type { DtActionsAtom } from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/state/atoms'
import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { AnggaranDataType } from './types'
import type { MutationAnggaranValues } from './validations'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['dana-alokasi-khusus', key] as const

const getAll = (
  params?: DtActionsAtom
): ServiceQueryOptionType<ServiceGetAllResponse<Array<AnggaranDataType>>> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<AnggaranDataType>>
      >(`kelembagaan/bpp/${params?.id_bpp}/dana-alokasi-khusus`, {
        params: {
          page: params?.page,
          per_page: params?.perPage || undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getById = (
  id: string,
  id_bpp?: string
): ServiceQueryOptionType<ServiceGetByIdResponse<AnggaranDataType>> => ({
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    try {
      const response = await api.get<ServiceGetByIdResponse<AnggaranDataType>>(
        `kelembagaan/bpp/${id_bpp ?? ''}/dana-alokasi-khusus/${id}`
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AnggaranDataType>,
  MutationAnggaranValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationAnggaranValues) => {
    try {
      const response = await api.post(
        `kelembagaan/bpp/${data.id_bpp ?? ''}/dana-alokasi-khusus`,
        {
          ...data
        }
      )

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AnggaranDataType>,
  MutationAnggaranValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationAnggaranValues) => {
    try {
      const response = await api.put<ServiceGetByIdResponse<AnggaranDataType>>(
        `kelembagaan/bpp/${data?.id_bpp ?? ''}/dana-alokasi-khusus/${data.id_anggaran}`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AnggaranDataType>,
  { id: string; id_bpp: string }
> => ({
  mutationFn: async (data: { id: string; id_bpp: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<AnggaranDataType>
      >(`kelembagaan/bpp/${data?.id_bpp ?? ''}/dana-alokasi-khusus/${data.id}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const anggaran = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  getById,
  create,
  update,
  deleteData
}
